import type { ILocalizationProvider } from "@edaz/services/baseLocalizationService";
import type { LocalizationContainer } from "services/localizationService";

import cs from "../localization/cs.json";

export default class LocalizationRepository implements ILocalizationProvider {
  get(language: string): Promise<LocalizationContainer> {
    return Promise.resolve(cs as any);
  }
}
